import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "axios";
import vuetify from "./plugins/vuetify";
//import Highcharts from "highcharts";
//import HighchartsVue from "highcharts-vue";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "leaflet/dist/leaflet.css";
import JsonCSV from "vue-json-csv";

Vue.config.productionTip = false;

//axios.defaults.baseURL = 'https://apiway.lubumas.com/api/';
//axios.defaults.baseURL = "http://localhost:5002/api/";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

//axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//Vue.use(HighchartsVue);
Vue.component("downloadCsv", JsonCSV);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");
